module.exports = __webpack_public_path__ + "static/media/createMp4.ddd107ff.png";